module.exports = __webpack_public_path__ + "img/logo@3x.2763dd14.png";